import createAxios from './http'
import getSign from '@/core'
import { getPhone, getSecret, getKey } from '@/common/js/cache'
const request = createAxios()
/**
* 拦截请求
*
*/
request.interceptors.request.use(
  config => {
    const accessSecret = getSecret()
    const accessKey = getKey()

    const timestamp = (new Date()).valueOf()
    const phone = getPhone()
    config.params = config.params || {}
    const params = config.params

    const signParams = {
      ...params,
      timestamp,
      accessKey,
      phone
    }
    const sign = getSign(signParams, accessSecret)
    config.params.timestamp = timestamp
    config.params.accessKey = accessKey
    config.params.sign = sign
    config.params.phone = phone
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

/**
 * 获取地区信息
 */
export function getHospitalRegion (params) {
  return request({
    url: '/doctor/getHospitalRegion.htm',
    method: 'post',
    params
  })
}

/**
 *  /doctor/getDepartments.htm
 *  获取地区
*/
export function getDepartments (params) {
  return request({
    url: '/doctor/getDepartments.htm',
    method: 'post',
    params
  })
}

/**
 * /doctor/getDoctorInfoList.htm
 * 获取医生列表
 */
export function getDoctorInfoList (params) {
  return request({
    url: '/doctor/getDoctorInfoList.htm',
    method: 'post',
    params
  })
}

/**
 * /doctor/getDoctorInfo.htm
 * 获取医生详情
 */
export function getDoctorInfo (params) {
  return request({
    url: '/doctor/getDoctorInfo.htm',
    method: 'post',
    params
  })
}

/**
 * /doctor/getAttachmentByDoctId.htm
 * 获取医生附件
 */
export function getAttachmentByDocId (params) {
  return request({
    url: '/doctor/getAttachmentByDoctId.htm',
    method: 'post',
    params
  })
}
